export const TODAY = new Date()